"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _axios = _interopRequireDefault(require("axios"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function baseRequest(method) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var axiosConfig = _objectSpread(_objectSpread({}, config), {}, {
    method: method
  });

  return _axios["default"].request(axiosConfig);
}

var _default = {
  get: function get(config) {
    return baseRequest('get', config);
  },
  put: function put(config) {
    return baseRequest('put', config);
  },
  post: function post(config) {
    return baseRequest('post', config);
  },
  patch: function patch(config) {
    return baseRequest('patch', config);
  },
  "delete": function _delete(config) {
    return baseRequest('delete', config);
  }
};
exports["default"] = _default;